import React, { useEffect, useState } from 'react';
import './CountDownTimer.scss';

interface ICountDownTimerProps {
    endDate: Date | undefined,
    messageWhenComplete: string,
    roundToDate: boolean,
}

const CountDownTimer: React.FC<ICountDownTimerProps> = (props) => {
    const [displayedTimerCountDown, setDisplayedTimerCountDown] = useState<string>(props.messageWhenComplete);

    const formatTimerString = (time: number) => {
        const days = Math.floor((time % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24))
        const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((time % (1000 * 60)) / 1000);
        
        const displayDays = (days < 10) ? "0" + days : days;
        const displayHours = (hours < 10) ? "0" + hours : hours;
        const displayMinutes = (minutes < 10) ? "0" + minutes : minutes;
        const displaySeconds = (seconds < 10) ? "0" + seconds : seconds;
    
        let displayTime = `${displayMinutes}:${displaySeconds}`;
        displayTime = hours ? `${displayHours}:${displayTime}`: displayTime;
        displayTime = days ? `${displayDays}:${displayTime}`: displayTime;
        return displayTime;
    }

    function roundDate(dateToRound: Date){
        const date = new Date(dateToRound);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date
    }

    useEffect(() => {
        let timer = 1000;
        if(props.endDate) {           
            const finishTime = props.roundToDate ? roundDate(props.endDate!).getTime() : props.endDate!.getTime();

            timer = window.setInterval(() => {
                const currentDateTime = Date.now();
                if(currentDateTime >= finishTime ) {
                    setDisplayedTimerCountDown(props.messageWhenComplete);
                    window.clearInterval(timer);
                } else {
                    setDisplayedTimerCountDown(formatTimerString(finishTime-currentDateTime));
                }
            }, 1000);
        } else {
            setDisplayedTimerCountDown(props.messageWhenComplete);
            window.clearInterval(timer);
        }  
        return () => {
            window.clearInterval(timer);
        }
    }, [props.endDate, props.messageWhenComplete, props.roundToDate])

    return (
        <div className="count-down-timer">
        {
            displayedTimerCountDown === props.messageWhenComplete ? displayedTimerCountDown : 
                <div>
                    <p>YOUR PLAN STARTS IN:</p>
                    <h2>{displayedTimerCountDown}</h2>
                </div>
        }
        </div>
    );
            
};

export default CountDownTimer;